var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.25 15H3.75V5.25C3.75 4.8375 3.4125 4.5 3 4.5C2.5875 4.5 2.25 4.8375 2.25 5.25V15C2.25 15.825 2.925 16.5 3.75 16.5H11.25C11.6625 16.5 12 16.1625 12 15.75C12 15.3375 11.6625 15 11.25 15ZM15 12V3C15 2.175 14.325 1.5 13.5 1.5H6.75C5.925 1.5 5.25 2.175 5.25 3V12C5.25 12.825 5.925 13.5 6.75 13.5H13.5C14.325 13.5 15 12.825 15 12ZM13.5 12H6.75V3H13.5V12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/Copy.3c453f0948e74f4d22ad89f00206607e.svg";
export { ForwardRef as ReactComponent };